import { render, staticRenderFns } from "./AlertasEstudio.vue?vue&type=template&id=9d51e846&scoped=true&"
import script from "./AlertasEstudio.vue?vue&type=script&setup=true&lang=js&"
export * from "./AlertasEstudio.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AlertasEstudio.vue?vue&type=style&index=0&id=9d51e846&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d51e846",
  null
  
)

export default component.exports